export default __webpack_public_path__ + "static/media/newsimplan-icon03-en.a51b6ca7.png";